import AddButton from "components/buttons/addbutton";
import ListHeadingComponent from "components/headingComponent/listHeading";
import {
  query,
  collection,
  or,
  and,
  where,
  getDocs,
  orderBy,
  deleteDoc,
  doc,
  endBefore,
  limit,
  limitToLast,
  startAfter,
  Timestamp,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import Constant from "helper/constant/constant";
import CommonHeadings from "helper/constant/headings";
import Dateformat from "helper/constant/timeFormat";
import RoutingPaths from "helper/routingPath";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import moment from "moment";
import React, { useEffect, useLayoutEffect } from "react";
import { useState } from "react";
import { ButtonGroup } from "react-bootstrap";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

function BasicExpensesList() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [expenseData, setExpenseData] = useState([]);
  const [filteredDates, setFilteredDates] = useState(null);
  const [page, setPage] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // MARK: checkUserRole
  function checkUserRole() {
    const userInfo = JSON.parse(localStorage.getItem("session"));
    setIsAdmin(userInfo.role === "admin");
  }

  // MARK: use Effect function
  useEffect(() => {
    checkUserRole();
    fetchExpenseApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.basicExpenseListLayoutHeading;
  }, []);

  const tapOnDateInput = (e) => {
    setFilteredDates(e.value);
  };

  // MARK: buttons function
  const tapOnEdit = (expenseData) => () => {
    navigate(RoutingPaths.editBasicExpenses, { state: expenseData });
  };

  const tapOnDeleteConfirm = (expenseData) => () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete this expense data`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        deleteExpenseApi(expenseData);
      }
    });
  };

  const tapOnFilterButton = async () => {
    const querySnapshot = await createQueryForTable();
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data() }));
    setExpenseData(array);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  async function createQueryForTable() {
    const filterText = filteredDates;

    if (!filterText) {
      toast.error(ToastMessages.filterDate);
      <ToastContainer />
    }

    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.basicExpenses),
        where("expense_date_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("expense_date_num", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.basicExpenses),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }

  const tapOnResetButton = () => {
    setFilteredDates(null);
    fetchExpenseApi();
  };

  // MARK: API's
  const deleteExpenseApi = async (expenseData) => {
    await deleteDoc(doc(dbFirestore, TableName.basicExpenses, expenseData.id));
    setExpenseData((prevState) =>
      prevState.filter((el) => el.id !== expenseData.id)
    );
    toast.success(ToastMessages.expenseDeleted);
  };

  async function fetchExpenseApi() {
    let q = query(
      collection(dbFirestore, TableName.basicExpenses),
      orderBy("created_at", "desc"),
      limit(Constant.perPage)
    );
    const querySnapshot = await getDocs(q);

    const expenseObject = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    setExpenseData(expenseObject);
    setPage(0);
    setLoading(false);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  }

  const searchExpenseApi = async (e) => {
    const searchText = e.target.value.toLowerCase();

    setGlobalFilterValue(searchText);

    if (searchText) {
      let q = query(
        collection(dbFirestore, TableName.basicExpenses),
        or(
          and(
            where("description", ">=", searchText),
            where("description", "<=", searchText + "\uf8ff")
          ),
          and(
            where(
              "description",
              ">=",
              searchText.charAt(0).toUpperCase() + searchText.slice(1)
            ),
            where(
              "description",
              "<=",
              searchText.charAt(0).toUpperCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          ),
          and(
            where(
              "description",
              ">=",
              searchText.charAt(0).toLowerCase() + searchText.slice(1)
            ),
            where(
              "description",
              "<=",
              searchText.charAt(0).toLowerCase() +
              searchText.slice(1) +
              "\uf8ff"
            )
          )
        )
      );
      const querySnapshot = await getDocs(q);

      // set data from docs
      setExpenseData(
        querySnapshot.docs.map((docs) => ({
          ...docs.data(),
          id: docs.id,
          firebase_id: docs.id,
        }))
      );
    } else {
      fetchExpenseApi();
    }
  };

  // MARK: pagination code
  const showNext = ({ item }) => {
    const fetchNextData = async () => {
      var paginationQuery;
      paginationQuery = query(
        collection(dbFirestore, TableName.basicExpenses),
        orderBy("created_at", "desc"),
        limit(Constant.perPage),
        startAfter(item.created_at)
      );

      const querySnapshot = await getDocs(paginationQuery);

      setExpenseData(
        querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
      );

      setPage(page + 1);
      setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
    };

    if (expenseData.length === 0) {
      alert(ToastMessages.alertMessage);
    } else {
      fetchNextData();
    }
  };

  // MARK: previous data function using pagination previous button
  const fetchPreviousData = async () => {
    setPage(page - 1);

    var paginationQuery;
    paginationQuery = query(
      collection(dbFirestore, TableName.basicExpenses),
      orderBy("created_at", "desc"),
      endBefore(expenseData[0].created_at),
      limitToLast(Constant.perPage)
    );

    const querySnapshot = await getDocs(paginationQuery);

    setExpenseData(
      querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }))
    );
    setPage(page - 1);
    setIsNext(querySnapshot.docs.length < Constant.perPage ? true : false);
  };

  // MARK: condition while selecting the previous button
  const showPrevious = () => {
    if (expenseData.length === 0) {
      fetchExpenseApi();
    } else {
      fetchPreviousData();
    }
  };

  // MARK: filter dates
  function getFilteredDatesTimeStamp() {
    if (filteredDates) {
      const startDate = moment(filteredDates[0]).format(Dateformat.YYYYMMDD);
      const endDate = moment(filteredDates[1]).format(Dateformat.YYYYMMDD);

      const startTimestamp = Timestamp.fromDate(new Date(startDate)).toMillis();
      const endTimestamp = Timestamp.fromDate(new Date(endDate)).toMillis();
      return { startTime: startTimestamp, endTime: endTimestamp };
    }
    return null;
  }

  //MARK: Search UI
  const searchBar = () => {
    return (
      <>
        <div className="search__main_div">
          <div style={{ flexGrow: "1" }}>
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                type="search"
                value={globalFilterValue}
                onChange={searchExpenseApi}
                placeholder="Search by description"
              />
            </IconField>
          </div>
          <div className="filter__button-section">
            <Calendar
              value={filteredDates}
              onChange={tapOnDateInput}
              selectionMode="range"
              readOnlyInput
              showIcon
              placeholder="Select start and end date"
            />

            <Button
              type="button"
              label="Filter"
              className="list__filter_button ms-2 me-2"
              onClick={tapOnFilterButton}
            />
            <Button
              type="button"
              label="Reset"
              className="list__reset_button"
              onClick={tapOnResetButton}
            />
          </div>
        </div>
      </>
    );
  };

  const header = searchBar();

  if (isLoading) {
    return <div className="loading-div"> Loading ... </div>;
  }

  // MARK: expense columns data
  const expenseListColumns = [
    { field: "amount", header: "Amount", CardBody: priceBodyTemplate },
    {
      field: "description",
      className: "table__column__capital",
      header: "Description",
    },
    {
      field: "expense_date",
      header: "Expense Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.expense_date}</Moment>
      ),
    },
    {
      field: "created_at",
      header: "Created At",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYHHMMSS}>{data.created_at}</Moment>
      ),
    },
    {
      field: "actions",
      header: "Actions",
      CardBody: (data) => (
        <>
          <div className="d-flex mt-3 text-start">
            <Button
              type="button"
              className="lists__edit_button"
              onClick={tapOnEdit(data)}
              tooltip="edit"
              tooltipOptions={{ position: "bottom" }}
            >
              <span className="pi pi-pencil"></span>
            </Button>

            {isAdmin && (
              <Button
                severity="secondary"
                type="button"
                onClick={tapOnDeleteConfirm(data)}
                className="lists__delete_button"
                tooltip="delete"
                tooltipOptions={{ position: "bottom" }}
              >
                <span className="pi pi-trash"></span>{" "}
              </Button>
            )}
            <ToastContainer />
          </div>
          <ToastContainer />
        </>
      ),
    },
  ];

  async function createQueryForExport() {
    const filterText = filteredDates;
    if (filterText) {
      let q = query(
        collection(dbFirestore, TableName.basicExpenses),
        where("expense_date_num", ">=", getFilteredDatesTimeStamp().startTime),
        where("expense_date_num", "<=", getFilteredDatesTimeStamp().endTime),
        limit(Constant.perPage),
        orderBy("created_at", "desc")
      );

      const querySnapshot = await getDocs(q);
      return querySnapshot;
    } else {
      let q = query(
        collection(dbFirestore, TableName.basicExpenses),
        orderBy("created_at", "desc"),
        limit(Constant.perPage)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot;
    }
  }


  // MARK: modify expense model in which we add new inputs in an array
  const modifyExpenseModel = (doc) => {
    const data = doc.data();

    return {
      expense_date: moment(data.expense_date).format(
        Dateformat.YYYYMMDD
      ),
      description: data.description,
      amount: data.amount_num,
      amount_num: null,
      created_at: moment(data.created_at).format(
        Dateformat.YYYYMMDD
      ),
    }
  };

  // MARK: export data in the excel sheet
  const exportToExcel = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to export these data.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.value) {
        const querySnapShot = await createQueryForExport();

        const mylist = querySnapShot.docs.map((model) => modifyExpenseModel(model));
        var expenseArray;
        expenseArray = mylist.map(({ expense_date, amount, description, created_at }) => ({
          expense_date: expense_date,
          amount: amount,
          description: description,
          created_at: created_at,
        }));
        if (filteredDates) {
          const workBook = XLSX.utils.book_new();
          const workSheet = XLSX.utils.json_to_sheet(expenseArray);
          XLSX.utils.book_append_sheet(workBook, workSheet, "expense");
          XLSX.writeFile(workBook, "basic_expense_data.xlsx");
        } else {
          toast.error(ToastMessages.filterDate);
        }
      }
    });
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <div className="modules__lists_main-content">
            <ListHeadingComponent
              classname="flex-grow-1"
              headingName="Basic Expense"
            />
            <Button
              label="Export Data"
              type="button"
              onClick={exportToExcel}
              className="list__export_button me-2"
            />
            <AddButton navigation={RoutingPaths.addBasicExpenses} />
          </div>

          <DataTable
            className="mt-5 mb-3"
            value={expenseData}
            header={header}
            emptyMessage="No data found."
          >
            {expenseListColumns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                bodyClassName={col.className}
                body={col.CardBody}
              />
            ))}
          </DataTable>

          <ButtonGroup
            style={{ gap: "1rem", alignSelf: "center" }}
            className="mt-5"
          >
            {
              <button
                disabled={page === 0 ? true : false}
                onClick={() => showPrevious()}
                className={
                  page === 0 ? "previous-disabled-button" : "previous-button"
                }
              >
                <span className="pi pi-angle-left">Previous</span>
              </button>
            }

            {
              <button
                disabled={isNext}
                onClick={() =>
                  showNext({ item: expenseData[expenseData.length - 1] })
                }
                className={
                  isNext ? "previous-disabled-button" : "previous-button"
                }
              >
                Next<span className="pi pi-angle-right"></span>
              </button>
            }
          </ButtonGroup>
        </div>
      </div>
    </div>
  );
}

const priceBodyTemplate = (expense) => {
  return `Rs ${expense.amount_num?.toLocaleString()}`;
};

export default BasicExpensesList;
